exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#locations[data-v-031fc196]{margin-top:80px}.page-title[data-v-031fc196]{margin-bottom:20px}.table th[data-v-031fc196]{border-top:none}.badge[data-v-031fc196]{font-size:.75em}.btn-group .btn[data-v-031fc196]{margin-right:2px}.btn-group .btn[data-v-031fc196]:last-child{margin-right:0}", ""]);

// exports
